import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-alert',
  imports: [
    CommonModule
  ],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss'
})
export class AlertComponent {

  @Input() type: 'success' | 'danger' | 'warning' | 'info' = 'info';

  getClass() {
    switch (this.type) {
      case 'success': return 'my-4 p-3 bg-green-100 text-green-700 rounded-md';
      case 'danger': return 'my-4 p-3 bg-red-100 text-red-700 rounded-md';
      case 'warning': return 'my-4 p-3 bg-yellow-100 text-yellow-700 rounded-md';
      default: return 'my-4 p-3 bg-blue-100 text-blue-700 rounded-md';
    }
  }

}
